<template>
  <v-card class="mx-auto flex-grow-1">
    <v-toolbar short color="red accent-2" dense dark elevation="0" class="m-0 p-0">
      <v-toolbar-title class="m-0 pt-4">
        <p class="subtitle-2 text-center white--text font-weight-normal">
          <v-icon class="mx-2" color="white">mdi-chart-pie</v-icon>
          Funcionários da empresa
        </p>
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="mx-auto my-5" max-width="344" elevation="0">
      <pie-chart :donut="true" :data="chartData"></pie-chart>
    </v-card>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
export default {
  data: () => {
    return {
      chartData: [
        ['Enfermeiro', 4],
        ['Médicos', 2],
        ['Técnicos Enfer.', 10],
        ['Administrativo', 5],
        ['Biomédicos', 3],
      ],
    }
  },
}
</script>